import angular from 'angular';
import settingsConfig from './settings.config';

import settings from '../../containers/settings';

const settingsModule = angular.module('meredicte.settings', [])
  .component('appSettings', settings)
  .config(settingsConfig);

export default settingsModule;



// WEBPACK FOOTER //
// ./src/modules/settings/settings.module.js